import CodedGradeContainer from '@src/components/codebook/CodedGradeContainer';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

type IAdminGradeCodebookPageProps = WithRouterProps;

const AdminGradeCodebookPage = (props: IAdminGradeCodebookPageProps) => <CodedGradeContainer />;

export default withRouter(AdminGradeCodebookPage as any);
